import { FormGroup } from "@angular/forms";
import { PointsArrangements } from "../_models/PointsArrangements";

export interface ICheckListInfoViewModel {
  Id: string;
  StatusId: string;
  InputTypeId: string;
  Label: string;
  Name: any;
  Value: string;
  Comments: string;
  Degree: number;
  Recommendations: string;
  Description: any;
  PhotoExplanation: any;
  Date: Date;
  Attachments: string[];
  Measurements: string[];
  AttributesList: string[];
  InspectionSubTypeId: string;
}

export interface IUtmGeneralSetingsViewModel {
  BulkheadsNoStifffners: Boolean;
  DeleteOldAutomaticPoints: Boolean;
  Date: string;
  Regions: any[];
}

export interface IUtmPlatesSettingsViewModel {
  PositionGaugingsforPlates: boolean
  PositionGaugingsforBays: boolean
  PositionPointCriteriaList: PlatesPointCriteria[]
  PointsArrangements: PointsArrangements
  PositionGaugingsforCriticalAreas: boolean
  CriticalAreaThreshold: number
  PositionGaugingsforAnomalies: boolean
  AnomaliesThreshold: number
}

export interface PlatesPointCriteria {
  Area: number;
  NumberOfPoints: number
  AddCenterPoint: boolean;
}

export interface IUtmStiffnersSetingsViewModel {
  PositionGaugingPointsOnStiffeners: boolean;
  PositionGaugingPointsOnBays: boolean;
  InsertPointsOnWeb: boolean;
  InsertPointsOnFlange: boolean;
  PositionPointCriteriaList: PositionPointCriteria[];
  PositionGaugingsforCriticalAreas: boolean
  CriticalAreaThreshold: number
}

export interface PositionPointCriteria {
  Length: number;
  NumberOfPoints: number;
}

export interface IUtmFacePlatesSetingsViewModel {
  PositionGaugingPointsOnFacePlates: boolean;
  PositionGaugingPointsOnBays: boolean;
  PositionPointCriteriaList: PositionPointCriteria[];
  PositionGaugingsforCriticalAreas: boolean
  CriticalAreaThreshold: number
}

export interface IUtmBracketSetingsViewModel {
  PositionGaugingPointsOnBrackets: boolean
  PositionGaugingPointsOnBays: boolean
  PositionPointCriteriaList: BracketPositionPointCriteria[];
  PointsArrangement: PointsArrangements;
  PositionGaugingsforCriticalAreas: boolean
  CriticalAreaThreshold: number
}

export interface BracketPositionPointCriteria {
  Area: number;
  NumberOfPointsWeb: number;
  NumberOfPointsFlange: number;
}

export interface IAreaSettingsViewModel {
  AreaForCriticalAreas: boolean;
}
export interface IRepairCriteria {
  aggregationRadius: string;
  representationRadius: string;
  minDistanceWelds: string;
  minDistanceRepairBoundariesSamePlate: string;
  minDistanceRepairBoundariesDifferentPlates: string;
  alignSidesRepairDistanceLessThan: string;
  maxAspectRatioRepairPlate: string;
  repairSizeIsolatedBadGaugingPoints: string;
  wholeElementAreaGreaterThan: string;
  discardRepairAreaLessThan: string;
  discardRepairRenewalProbabilityLessThan: string;
  discardRepairRemainingLifeGreaterThan: string;
  discardRepairRelativeDegradationLessThan: string;
  discardRepairCorrosionRateLessThan: string;
}

export enum RepairScopeTypes {
  OnlyDamaged = 0,
  DamagedAndAttached = 1,
  CustomTable = 2,
}

export enum RenewThicknessTypes {
  Original = 0,
  Rule = 1
}

export interface IRiskShieldColumnData {
  Name: string;
  ColumnId: string;
  Value: boolean;
  Deadline: string;
  NextCycle: boolean;
  Repeat: boolean;
  DeactivateCriticalArea: boolean;
  ShouldReduceRisk: boolean;
}

export interface IRiskShieldDataRow {
  RowId: string;
  // RowName: string;
  Columns: IRiskShieldColumnData[];
}

export interface TriageTableRow {
  actionName: string;
  id: string;
}

export interface IRiskShieldDataTab {
  RiskLevelConfigId: string;
  RiskShieldDataRow: IRiskShieldDataRow[],
}

export interface FormGroupTab {
  riskLevelConfigId: string;
  table: FormGroup[];
}

export interface IRiskSelectedColors {
  [categoryId: number]: {
    [colorId: number]: string;
  };
}

export interface IRiskSelectedLevels {
  improveInspectionRiskLevel1: RiskLevel;
  improveInspectionRiskLevel2: RiskLevel;
  mitigationActionsRiskLevel1: RiskLevel;
  mitigationActionsRiskLevel2: RiskLevel;
  prescribeRepairsRiskLevel1: RiskLevel;
  prescribeRepairsRiskLevel2: RiskLevel;
}

export enum RiskLevel {
  None,
  Low,
  Medium,
  High,
  VeryHigh,
}

export interface IRiskLevelConfig {
  id: string;
  name: string;
  color: string;
  order: number;
}

export interface InspectionTypeOption {
  id: string
  label: string
}

export interface ActionExclusionGroup {
  prescribedActionId: string;
  excludedActionIds: string[];
}

export interface ActionConfig {
  actionId: string;
  deactivateCriticalArea: boolean;
}

export interface IPostRbaAnalysisConfig {
  analysisEndOffsetDays: number;
  selectedProperties: string[];
}

export interface RiskShieldConfiguration {
  id: string;
  AssetId: string;
  RepairCriteria: IRepairCriteria;
  RepairScope: RepairScopeTypes;
  RenewThickness: RenewThicknessTypes;
  InspectionTriageTableTab: IRiskShieldDataTab[];
  MitigationTriageTableTab: IRiskShieldDataTab[];
  RepairTriageTableTab: IRiskShieldDataTab[];
  RiskSelectedLevels: IRiskSelectedLevels
  ActionExclusionGroups: ActionExclusionGroup[]
  ActionConfigs: ActionConfig[]
  PostRbaAnalysisConfig: IPostRbaAnalysisConfig
  //utm-model
  CollectionId: string;
  Label: string;
  Date: Date;
  InspectionTypeId: string;
  InspectionTypeName: string;
  InspectionMethodId: string;
  CheckLists: ICheckListInfoViewModel[];
  GeneralSettings: IUtmGeneralSetingsViewModel;
  PlatesSettings: IUtmPlatesSettingsViewModel;
  StiffenersSettings: IUtmStiffnersSetingsViewModel;
  FacePlatesSettings: IUtmFacePlatesSetingsViewModel;
  BracketSettings: IUtmBracketSetingsViewModel;
  AreaSettings: IAreaSettingsViewModel;
  UserId: string;
  ExecuteRiskShield: boolean;
}
